import * as styles from "./QRCode.module.css";
import qrCode from "../../assets/svg/qr-code.svg";

const QRCode = () => {
  return (
    <div className={styles.QRCodeParent}>
      <div className={styles.QRCodeContent}>
        <h3 className={styles.QRCodeHeading}>Claim 3 free stocks ~₹300</h3>
        <p className={styles.QRCodeDesc}>Download Returns</p>
      </div>
      <img className={styles.qrCode} src={qrCode} alt="" />
    </div>
  );
};

export default QRCode;
